<template>
	<div class="loginContent">
		<div class="form">
			<h2 v-if="$mq=='lg'" v-html="myLang('pages/login.traveler-login')"></h2>

			<div v-if="stepOne" class="step step-1" :class="{active : stepOne}">
				<h2 class="mobileTitle" v-if="$mq=='sm'">{{'pages/login.to-login-enter-email' | trans }}</h2>

				<div class="inputWrap" :class="{error: $v.userEmail.$error}">
					<label for="email">{{'pages/login.email' | trans }}</label>
					<input :v="$v.userEmail" v-model="userEmail" type="email" placeholder="E-mail" name="email"
						   id="email">
					<div class="error" v-if="$v.userEmail.$error">
						<div v-if="!$v.userEmail.required">{{'pages/login.email-required' | trans }}</div>
						<div v-if="!$v.userEmail.email">{{'pages/login.email-invalid' | trans }}</div>
					</div>
					<div class="error" v-if="!$v.userEmail.$error">
						<div v-if="!userEmailValidating">{{userEmailValidatingMessage}}</div>
					</div>
				</div>

				<button @click="gotoStepTwo" class="btn">
					<PulseLoader v-if="userEmailValidating" color="#fff" size="7px"/>
					<span v-if="!userEmailValidating">{{'pages/login.login' | trans }}</span>
				</button>
				<div class="terms">
					{{'pages/login.i-confirm' | trans({name: ''}) }}
					<a @click.prevent="termsAndConditions" href="">{{'pages/login.terms' | trans }}</a>
					{{'pages/login.and' | trans }}
					<a @click.prevent="privacyPolicy" href="">{{'pages/login.privacy-policy' | trans }}</a>
				</div>
			</div>
			<div v-if="stepTwo" class="step step-2" :class="{active : stepTwo}">
				<div class="stepWrap">
					<div class="wrap">
						<img v-if="$mq=='sm'" class="email" src="assets/img/email.svg" alt="email">
						<h3>{{'pages/login.login-is-sent' | trans }}</h3>
						<p>
							{{'pages/login.login-link-sent-to-email' | trans({email: userEmail}) }}.
							{{'pages/login.check-email' | trans }}.
						</p>
						<p>
							<a @click.prevent="goToStepOne" href="">
								<strong>{{'pages/login.back' | trans }}</strong>
							</a>
						</p>
					</div>
				</div>
			</div>
		</div>
		<div class="photos" :class="{stepOne : stepOne && $mq=='sm'}">
			<div class="photo photo-1">
				<img src="/assets/img/login/travel3.png" alt="travel3">
			</div>
			<div class="photos-column">
				<div class="photo photo-2">
					<img src="/assets/img/login/travel1.png" alt="travel1">
				</div>
				<div class="photo photo-3">
					<img src="/assets/img/login/travel2.png" alt="travel2">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import {required, email, minLength, numeric} from 'vuelidate/lib/validators';
    import myLang from "../mixins/myLang";
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';
	  import region from "../mixins/region";

    export default {
        data() {
            return {
                stepOne: true,
                stepTwo: false,
                userEmail: '',
                userEmailValidating: false,
				        userEmailValidatingMessage: '',
            }
        },

        mixins: [myLang, region],
        components: {
            PulseLoader
        },

        validations: {
            userEmail: {
                required,
                email
            },
            pinCode: {
                required,
                numeric,
                minLength: minLength(4),
            }
        },

        mounted() {
            localStorage.removeItem('vuex');
        },

        methods: {
            termsAndConditions: function () {
              let regionSegment = this.getRegionUrlSegment();
              window.open('https://www.getvuelo.com/' + regionSegment + '/terms-and-conditions', '_blank');
            },
            privacyPolicy: function () {
                let regionSegment = this.getRegionUrlSegment();
                window.open('https://www.getvuelo.com/' + regionSegment + '/privacy-policy', '_blank');
            },
            gotoStepTwo: function () {
                this.$v.userEmail.$touch();

                if (this.$v.userEmail.$error) return;

                this.userEmailValidating = true;
				this.userEmailValidatingMessage = '';
                axios.post('/api/auth/validate', {'email': this.userEmail}).then(res => {
                    this.userEmailValidating = false;
                    if (res.data.error === false) {

                        this.stepOne = false;
                        this.stepTwo = true;
                    } else {
						this.userEmailValidatingMessage = res.data.messages[0].body;
					}
                });
            },
            goToStepOne: function () {
                this.stepOne = true;
                this.stepTwo = false;
            }
        },
    }
</script>
